import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { RouteFacade } from '@wdx/shared/infrastructure/state';
import {
    FeatureFlag,
    FeaturesService,
    FormDisplayMode,
    NavItem,
    Privilege,
} from '@wdx/shared/utils';
import { filter, take } from 'rxjs';
import { BaseSearchBarClass } from '../../../classes/base-search-bar.class';
import { RandomStringPipe } from '../../../pipes/random-string.pipe';
import { IMPORT_EXPORT_ENTITY_FEATURE_FLAGS_MAP } from '../../../shared/components/hybrid-select-menu/hybrid-select-menu.constant';
import { FilterQueryService } from '../../../shared/features/form-filters';
import { RouteDataService } from '../../../shared/services/route-data/route-data.service';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'molecule-search-and-filter-bar',
    templateUrl: './molecule-search-and-filter-bar.component.html',
    standalone: false,
})
export class MoleculeSearchAndFilterBarComponent
    extends BaseSearchBarClass
    implements OnInit
{
    @Output() sort = new EventEmitter<string>();

    instanceId: string;
    showImportExport: boolean;
    importPrivilege!: Privilege;
    exportPrivilege!: Privilege;

    readonly FORM_DISPLAY_MODE = FormDisplayMode;
    readonly FEATURE_FLAG = FeatureFlag;

    constructor(
        public routeDataService: RouteDataService,
        private featuresService: FeaturesService,
        private filterQueryService: FilterQueryService,
        private routeFacade: RouteFacade,
    ) {
        super();
    }

    ngOnInit() {
        this.routeFacade
            .getRouteDataField$('dropdownMenuPrivileges')
            .pipe(take(1), filter(Boolean))
            .subscribe(
                (dropdownMenuPrivileges: {
                    export: Privilege;
                    import: Privilege;
                }) => {
                    this.importPrivilege = dropdownMenuPrivileges?.import;
                    this.exportPrivilege = dropdownMenuPrivileges?.export;
                },
            );
        this.instanceId = new RandomStringPipe().transform();

        this.showImportExport = Boolean(
            this.featuresService.hasFeature(FeatureFlag.Exports) ||
                Object.values(IMPORT_EXPORT_ENTITY_FEATURE_FLAGS_MAP).some(
                    (featureFlag) =>
                        this.featuresService.hasFeature(
                            featureFlag as FeatureFlag,
                        ),
                ),
        );
    }

    onSort(sortMenuItem: NavItem): void {
        this.sort.emit(sortMenuItem?.id);
    }
}
